import { Injectable, inject } from '@angular/core'
import { contract } from '@ftr/annotations-contracts'
import { API_CONFIGURATION, FullApiClientConfiguration } from '@ftr/api-shared'
import { Region } from '@ftr/contracts/type/court'
import { AnnotationsApiClientFactoryBase } from './annotations-api-client.factory.base'
import { AnnotationsApiClient } from './types'

/**
 * Create a client service for ftr-annotations for a given region
 */
@Injectable({
  providedIn: 'root',
})
export class AnnotationsApiClientFactory extends AnnotationsApiClientFactoryBase {
  private readonly config = inject<FullApiClientConfiguration>(API_CONFIGURATION)

  build(region: Region): AnnotationsApiClient {
    const baseUrl = this.config.annotationsApi.endpointMap[region]
    return this.buildClient(baseUrl, contract)
  }
}
